import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ValidateEmail from "./ValidateEmail";
import LoginForm from "./Login";

import "./Login.css";
import SignupForm from "./Signup";

const LoginOrCreateAccount = ({navBlock, onNext}) => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showLogin, setShowLogin] = useState(true);
  const [showSignup, setShowSignup] = useState(false);
  const [validatedEmail, setValidatedEmail] = useState(null);
  const main = process.env.REACT_APP_MAIN;
  const handleLoginSuccess = () => {
    if (!navBlock){
      navigate(main + "perfil");
    } else{
      onNext();
    }
    
  };

  const onBack = () => {
      setShowSignup(false);
  };

  const handleValidateEmailSuccess = (email, password) => {
    setValidatedEmail(email);
    setPassword(password);
      setShowSignup(true);
  };


  return (
    <div className="login-or-create-container">
          {showSignup && (<SignupForm
        email={validatedEmail}
        password={password}
        onSignupSuccess={handleLoginSuccess}
        onBack={onBack}
      />)}

      {!showSignup && (
        <>
          <ValidateEmail onValidateSucess={handleValidateEmailSuccess} />
          <LoginForm onLogin={handleLoginSuccess} />
        </>
      )}
    </div>
  );
};

export default LoginOrCreateAccount;
